module.exports = __webpack_public_path__ + "img/logo1-1.f6d534dd.png";